<div *ngIf="config != undefined" class="mainContainer" fxLayout="column" fxLayoutAlign="center center">


  <main class="card" fxLayout="column" fxLayoutAlign="center center">
    <!-- <div>
       <button class="card-button" mat-flat-button color="accent" (click)="applyToAllGroup(config)">{{'applyToAll' | translation}}</button>
     </div>-->
    <div fxLayout="column" fxLayoutAlign="center center" class="line">


      <section class="card-section">
        <p class="card-title">{{'startText' | translation}}</p>
        <p class="card-data">{{config.startText}}</p>
        <button class="card-button" mat-flat-button color="accent" (click)="showModal('startTextValue',startTextValue)">Modifier le texte</button>
        <!-- <mat-divider [inset]="true"></mat-divider> -->
      </section>

    </div>

    <div class="divider"> </div>

    <div fxLayout="column" fxLayoutAlign="center center" class="line">
      <section class="card-section toggle">
        <!-- <p class="card-data">Une seule participation par utilisateur</p>-->
        <span (click)="config.gameActive = !config.gameActive; changeValue()" class="card-title">        {{'activateGame' | translation}}</span>
        <mat-slide-toggle labelPosition="before" color="accent" type="checkbox" [(ngModel)]="config.gameActive" (ngModelChange)="changeValue()">


        </mat-slide-toggle>

        <!-- <mat-divider [inset]="true"></mat-divider> -->
      </section>
      <section class="card-section">
        <div class=" toggle">

          <span class="card-title" (click)="config.quizActive = !config.quizActive; changeValue()">          {{'activateQuiz' | translation}}</span>
          <!-- <p class="card-data">Une seule participation par utilisateur</p>-->
          <mat-slide-toggle labelPosition="before" color="accent" type="checkbox" [(ngModel)]="config.quizActive" (ngModelChange)="changeValue()">


          </mat-slide-toggle>

        </div>
        <div *ngIf="config.quizActive && _shared.selectedDevice.data.modules.media && allQuiz.length > 0">
          <mat-form-field appearance="fill">
            <mat-label *ngIf="selectedQuiz?.data">{{selectedQuiz?.data.name}}</mat-label>
            <mat-select [(ngModel)]="selectedQuiz" (selectionChange)="changeValue()">

              <mat-option *ngFor="let item of allQuiz" [value]="{id: item.id, data: item.data}">
                {{item.data.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <!-- <mat-divider [inset]="true"></mat-divider> -->
      </section>

      <section class="card-section toggle emailConfigurationContainer" *ngIf="_shared.checkAppVersion('1.21.17', 'media')">
        <div>


          <!-- <p class="card-data">Une seule participation par utilisateur</p>-->
          <span class="card-title" (click)="config.sendConfirmation = !config.sendConfirmation; changeValue()">        {{'sendEmail' | translation}}</span>
          <mat-slide-toggle labelPosition="before" color="accent" type="checkbox" [(ngModel)]="config.sendConfirmation" (ngModelChange)="changeValue()">


          </mat-slide-toggle>
        </div>
        <ng-container *ngIf="config.sendConfirmation">

          <div id="emailConfigurationDetails">
            <span class="card-title">        {{'sendToWinner' | translation}}</span>
            <mat-slide-toggle labelPosition="before" color="accent" type="checkbox" [(ngModel)]="config.emailConfiguration.onlyWin" (ngModelChange)="changeValue()">
            </mat-slide-toggle>

            <div id="emailObject">
              <span class="card-title">{{'emailObject' | translation}}</span>
              <mat-form-field appearance="fill">

                <input matInput placeholder="" [(ngModel)]="config.emailConfiguration.object" (blur)="changeValue()">
              </mat-form-field>
            </div>

            <div id="emailContent">
              <div id="emailContentInfos">
                <span class="card-title">{{'emailContent' | translation}}</span>
                <span class="material-icons iconContainer info" (click)="openTutoEmailContent()">
                  info
                </span>
              </div>
              <mat-form-field appearance="fill">


                <textarea matInput [(ngModel)]="config.emailConfiguration.content" (blur)="changeValue()"></textarea>
              </mat-form-field>
            </div>


          </div>

        </ng-container>
        <!-- <mat-divider [inset]="true"></mat-divider> -->
      </section>
      <section class="card-section toggle">
        <!-- <p class="card-data">Une seule participation par utilisateur</p>-->
        <span class="card-title" (click)="config.canPlayMultiple = !config.canPlayMultiple; changeValue()">        {{'oneTry' | translation}}</span>
        <mat-slide-toggle labelPosition="before" color="accent" type="checkbox" [(ngModel)]="config.canPlayMultiple" (ngModelChange)="changeValue()">


        </mat-slide-toggle>

        <!-- <mat-divider [inset]="true"></mat-divider> -->
      </section>

    </div>

    <div class="divider"> </div>

    <h1>{{'gamePeriode' | translation}}</h1>

    <div class="line" fxLayout="row" fxLayoutAlign="space-around center">



      <div>

        <p>{{'startDate' | translation}}</p>
        <mat-form-field>

          <input matInput [matDatepicker]="startDatePicker" [(ngModel)]="config.startDate" (ngModelChange)="changeValue()" disabled>
          <mat-datepicker-toggle name="startDatePicker" ngDefaultControl matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker disabled="false"></mat-datepicker>
        </mat-form-field>
      </div>

      <div>
        <p>{{'endDate' |translation}}</p>
        <mat-form-field>

          <input matInput [matDatepicker]="endDatePicker" [min]="config.startDate" [(ngModel)]="config.endDate" (ngModelChange)="changeValue()" disabled>
          <mat-datepicker-toggle name="endDatePicker" ngDefaultControl matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker disabled="false"></mat-datepicker>
        </mat-form-field>
      </div>

    </div>

    <div class="divider"> </div>

    <div class="line" fxLayout="row" fxLayoutAlign="space-around center">
      <div>
        <p>{{'startTime' | translation}}</p>
        <ngx-timepicker-field [format]="24" [(ngModel)]="config.startTime" (ngModelChange)="changeValue()"></ngx-timepicker-field>
      </div>
      <div>
        <p>{{'endTime' | translation}}</p>
        <ngx-timepicker-field [format]="24" [(ngModel)]="config.endTime" (ngModelChange)="changeValue()"></ngx-timepicker-field>
      </div>
    </div>


    <div class="divider"> </div>

    <h1>{{'soundConfig' |translation}}</h1>


    <div *ngIf="config.sound" class="line" fxLayout="row" fxLayoutAlign="space-around center">
      <app-audio-import [title]="'Son de l\'application'" [(enable)]="config.sound.loop.enable" [type]="'loop'" [(url)]="config.sound.loop.data.url" [(name)]="config.sound.loop.data.name"></app-audio-import>
      <app-audio-import [title]="'Son de victoire'" [(enable)]="config.sound.win.enable" [type]="'win'" [(url)]="config.sound.win.data.url" [(name)]="config.sound.win.data.name"></app-audio-import>
      <app-audio-import [title]="'Son de (défaite)'" [(enable)]="config.sound.lose.enable" [type]="'lose'" [(url)]="config.sound.lose.data.url" [(name)]="config.sound.lose.data.name"></app-audio-import>
    </div>

    <div class="divider"> </div>

    <h1>{{'gameConfig' | translation}}</h1>

    <div class="line" fxLayout="column" fxLayoutAlign="space-around center">



      <div>

        <p>{{'gameType' | translation}}</p>
        <mat-form-field appearance="fill">
          <select matNativeControl required [(ngModel)]="config.gameType" (ngModelChange)="changeValue()">
            <option value="wheel">Roue de la fortune</option>
            <option value="slot">Bandit Manchot</option>
          </select>
        </mat-form-field>
        <!-- <mat-form-field>

          <input matInput [matDatepicker]="startDatePicker" [(ngModel)]="config.startDate" (ngModelChange)="changeValue()" disabled>
          <mat-datepicker-toggle name="startDatePicker" ngDefaultControl matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker disabled="false"></mat-datepicker>
        </mat-form-field>-->
      </div>

      <div fxLayout="column" fxLayoutAlign="space-around center" *ngIf="config">

        <div>
          <p class="card-title">{{'backgroundColor' | translation}}</p>
          <div class="color-thumb" [style.background]='config.colorBackground'></div>
          <button class="card-button" mat-flat-button color="primary"
                  (click)="showColorModal(config.colorBackground, 'background')">
            {{'changeColor' | translation}}
          </button>
        </div>
        <div>
          <p class="card-title">{{'fontColor' | translation}}</p>
          <div class="color-thumb" [style.background]='config.colorText'></div>
          <button class="card-button" mat-flat-button color="primary"
                  (click)="showColorModal(config.colorText, 'text')">
            {{'changeColor' | translation}}
          </button>
        </div>

        <div>
          <p class="card-title">{{'keyboardPosition' | translation}} (v1.7.8)</p>
          <mat-form-field appearance="fill">
            <mat-select [(value)]="config.keyboardPosition" (selectionChange)="changeValue()">
              <mat-option value="bottom">En bas</mat-option>
              <mat-option value="top">En haut</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!--   <div>
                    <p class="card-title">{{'keyboardPosition' | translation}}</p>

        </div>-->
        <!--  <div>
          <p class="card-title">{{'buttonColor' | translation}}</p>
          <div class="color-thumb" [style.background]='config.colorButton'></div>
          <button class="card-button" mat-flat-button color="primary"
                  (click)="showColorModal(config.colorButton, 'button')">
            {{'changeColor' | translation}}
          </button>
        </div>-->

      </div>



      <div fxLayout="column" fxLayoutAlign="flex-start center" class="image-upload-wrapper">
        <h2>{{'background' | translation}}</h2>

        <!-- <span class="spinner">
          <mat-spinner [diameter]="36"></mat-spinner>
        </span>-->


        <div class="empty-image-bg">
          <ng-container *ngIf="config.endBackground">
            <img id="thumbnail" #thumbnail [hidden]="config.endBackground.url == undefined || config.endBackground.url.length == 0 || config.endBackground.name.includes('.mp4')" [src]="config.endBackground.url ||''" alt="Aucune image" />
            <mat-icon *ngIf="config.endBackground.name != undefined && config.endBackground.name.includes('.mp4') && config.endBackground.url != undefined && config.endBackground.url.length > 0">video_library</mat-icon>
          </ng-container>

        </div>
        <span class="logoButtonContainer" fxLayout="row">
          <button (click)="uploadElement()" mat-mini-fab>
            <mat-icon>edit</mat-icon>
          </button>
          <button (click)="deleteLotteryBackgroundElement(config.endBackground)" style="{z-index: 1;}" mat-mini-fab
                  color="warn">
            <mat-icon>delete</mat-icon>
          </button>
        </span>
      </div>

      <ng-container *ngIf="config.gameType == 'wheel' && _shared.checkAppVersion('1.21.1', 'media')">
        <div fxLayout="column" fxLayoutAlign="flex-start center" class="image-upload-wrapper videoWrapper">
          <h2>{{'backgroundWheel' | translation}}</h2>

          <!-- <span class="spinner">
            <mat-spinner [diameter]="36"></mat-spinner>
          </span>-->


          <div class="empty-image-bg">
            <ng-container *ngIf="config.wheelBackground">
              <img id="thumbnail" #thumbnail [hidden]="config.wheelBackground.url == undefined || config.wheelBackground.url.length == 0 || config.wheelBackground.name.includes('.mp4')" [src]="config.wheelBackground.url ||''" alt="Aucune image" />
              <mat-icon *ngIf="config.wheelBackground.name != undefined && config.wheelBackground.name.includes('.mp4') && config.wheelBackground.url != undefined && config.wheelBackground.url.length > 0">video_library</mat-icon>

            </ng-container>

          </div>
          <span id="videoName">{{config.wheelBackground?.defaultName}}</span>

          <span class="logoButtonContainer" fxLayout="row">
            <button (click)="uploadElement('wheelBackground')" mat-mini-fab>
              <mat-icon>edit</mat-icon>
            </button>
            <button (click)="deleteLotteryBackgroundElement(config.wheelBackground)" style="{z-index: 1;}" mat-mini-fab
                    color="warn">
              <mat-icon>delete</mat-icon>
            </button>
          </span>
        </div>
      </ng-container>

    </div>
    <div class="divider"> </div>


    <h1>{{'prizeManagement' | translation}}</h1>

    <div *ngIf="config.prizeArray != undefined " class="line" fxLayout="column" fxLayoutAlign="center center">
      <div fxLayout="row">
        <p>{{'latestUpdate' | translation}}: {{lastUpdate | date:'short'}}</p>
      </div>
      <div>
        <h2>Attention, le nombre de lots à distribuer est journalier</h2>
      </div>
      <div fxLayout="row">
        <button (click)="addPrize()" class="card-button" mat-flat-button color="accent">
          <mat-icon>add</mat-icon>
          {{'addPrize' | translation}}
        </button>
      </div>




      <div class="prizes-wrapper">




        <mat-card class="lot-wrapper">
          <mat-card-title>
            PERDU
          </mat-card-title>

          <mat-divider></mat-divider>
          <mat-card-actions>
            <button (click)="updatePrize(prizeArray[0], 0)" class="card-button" mat-mini-fab color="accent">
              <mat-icon>settings</mat-icon>
            </button>



          </mat-card-actions>
        </mat-card>

        <mat-card class="lot-wrapper"
                  *ngFor="let item of prizeArray | slice:1; let i = index">


          <mat-card-subtitle>
            Lot n°{{i+1}}
          </mat-card-subtitle>

          <mat-card-title *ngIf="item.descriptif">
            {{item.descriptif}}
          </mat-card-title>


          <mat-divider></mat-divider>

          <mat-card-content>
            <div class="option">
              <p>{{'initQuant' | translation}} : </p>
              <h2>{{item.currentQuantity}} / {{item.nbr}}</h2>
            </div>



            <div class="option" *ngIf="config.gameType == 'wheel' || config.gameType == undefined">
              <p>{{'color' | translation}}</p>
              <div class="colorDiv" [ngStyle]="{'background': item.color}"></div>
            </div>


            <div class="option" *ngIf="config.gameType == 'slot'">
              <p>{{'icone' | translation}}</p>
              <div class="iconeDiv" click="uploadSymbolSlot(item)">
                <img *ngIf="!item.imgData" [src]="'assets/symbol/' + i  + '.jpg'" alt="TEST" />
                <img *ngIf="item.imgData" [src]="item.imgData.url" alt="TEST" />
              </div>
            </div>





            <!-- <p>Stock actuel : {{item.currentQuantity}}</p> -->
            <!-- <p>Description: {{item.resultText}}</p> -->
            <!-- <p>Champ gagnant : {{item.isWinner}}</p> -->

          </mat-card-content>
          <mat-divider></mat-divider>

          <mat-card-actions>
            <button (click)="updatePrize(item, i + 1)" class="card-button" mat-mini-fab color="accent">
              <mat-icon>settings</mat-icon>
            </button>

            <button (click)="removeFromPrizeArray(i + 1)" class="card-button" mat-mini-fab color="warn">
              <mat-icon>delete</mat-icon>
            </button>



          </mat-card-actions>







        </mat-card>




        <!-- PERDU -->
        <!--   <mat-card class="lot-wrapper"
                      *ngIf="config.gameType == 'wheel' || config.gameType == undefined">





              <mat-card-title>
                {{prizeArray[0].descriptif}}
              </mat-card-title>

              <mat-divider></mat-divider>

              <mat-card-content>

                <div class="option">
                  <p>{{'initQuant' | translation}}</p>
                  <h2>{{prizeArray[0].nbr}}</h2>
                </div>

                <div class="option">
                  <p>{{'currentQuant' | translation}}</p>
                  <h2>{{prizeArray[0].currentQuantity}}</h2>
                </div>

                <div class="option">
                  <p>{{'color' | translation}}</p>
                  <div class="colorDiv" [ngStyle]="{'background': prizeArray[0].color}"></div>
                </div>


              </mat-card-content>


              <mat-divider>

              </mat-divider>

              <mat-card-actions>


                <button (click)="updatePrize(prizeArray[0], 0)" class="card-button" mat-mini-fab color="accent">

                  <mat-icon>settings</mat-icon>
                </button>

                <button class="card-button" mat-mini-fab color="warn" style="opacity: 0; ">
                  <mat-icon>delete</mat-icon>
                </button>


              </mat-card-actions>

            </mat-card>-->
        <!-- FIN PERDU -->




      </div>


    </div>





  </main>
</div>
